import { __ } from '../../utils';
import Person from '@mui/icons-material/Person';
import { useAuth } from '@presov.sk/presov-auth-react';
import { UserMenu } from '@presov.sk/presov-ui-react';
import React from 'react';

/**
 * Používateľ v hlavičke. Auth zostáva v aplikácii - knižnica sa na `auth-react`
 * neviaže - takže tento komponent je len adaptér: vezme `authUser` a `logout`
 * a naplní `UserMenu` z knižnice. Rovnako to má cimpo.
 *
 * `UserMenu` je lišta s **menom a iniciálkami**, nie samotné koliesko: koliesko
 * nedávalo ani dostatočný cieľ na dotyk, ani informáciu o tom, kto je
 * prihlásený.
 *
 * **Body ani prstenec úrovne tu nie sú.** Gamifikácia patrí do profilu, kde je
 * na ňu miesto aj popis úrovne; v hlavičke z nej bol drobný krúžok s číslom,
 * ktorý nikto nečítal. Profil ju kreslí ďalej cez [[UserAvatar]].
 */
const HeaderUser: React.FC = () => {
  const { authUser, logout } = useAuth();

  const name = [authUser?.name, authUser?.surname].filter(Boolean).join(' ');

  return (
    <UserMenu
      name={name || __('Účet')}
      email={authUser?.email}
      items={[
        {
          // `href`, nie `onClick`: položka je odkaz, takže sa profil dá otvoriť
          // aj v novej karte. Routovanie vybaví `LinkProvider`, ktorý inštaluje
          // shell zo svojho `onNavigate`.
          label: __('Profil'),
          icon: <Person />,
          href: '/profil',
        },
      ]}
      onSignOut={() => logout()}
      signOutLabel={__('Odhlásiť sa')}
    />
  );
};

export default HeaderUser;
